export default __webpack_public_path__ + "static/media/69@2x-8.6bcc2fd2.png";